import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">KPawar</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Projects</a>
                    </li>

                    <li>
                        <a href="#testimonials" className="footer__link">Testimonials</a>
                    </li>
                </ul>

                <div className="footer__social">
                    <a href="https://api.whatsapp.com/send?phone=+919172121327&text=Hello...!" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-whatsapp"></i>
                    </a>

                    <a href="https://www.instagram.com/mr._kamlesh_pawar_" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-instagram"></i>
                    </a>

                    <a href="https://twitter.com/kamlesh_pawar_" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-twitter"></i>
                    </a>
                </div>

                <span className='footer__copy'>
                    &#169; KPawar. All rigths reserved
                </span>
            </div>
        </footer>
    )
}

export default Footer